export default __webpack_public_path__ + "static/media/badge-header.2c3af956.svg";